import { render, staticRenderFns } from "./ViewFieldTag.vue?vue&type=template&id=450ca078&scoped=true"
import script from "./ViewFieldTag.vue?vue&type=script&lang=js"
export * from "./ViewFieldTag.vue?vue&type=script&lang=js"
import style0 from "./ViewFieldTag.vue?vue&type=style&index=0&id=450ca078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ca078",
  null
  
)

export default component.exports